<template>
  <div class="container">
    <div class="tip">请选择以下一种证件进行提交</div>
    <van-radio-group
      v-model="radio"
      direction="horizontal"
      class="radio-group"
    >
      <van-radio
        name="0"
        icon-size="0.4rem"
        class="radio-text"
        @click.stop.native="radioClick('0')"
        disabled
      >上传营业执照</van-radio>
      <van-radio
        name="1"
        icon-size="0.4rem"
        class="radio-text"
        @click.stop.native="radioClick('1')"
        disabled
      >上传身份证</van-radio>
    </van-radio-group>
    <van-form
      validate-first
      @failed="onFailed"
      :show-error-message="false"
      :show-error="false"
      scroll-to-error
      @submit="onSubmit"
    >
      <div class="uploader">
        <van-field
          name="cardUp"
          :rules="[{ validator: asyncValidator, message: `${radio == 0 ? '请上传营业执照' : '请上传身份证正面'}`, trigger:onSubmit }]"
          style="padding: 0;flex: 0 0 3.73333rem"
        >
          <template #input>
            <div class="uploader-common">
              <van-uploader
                name="cardUp"
                :after-read="afterRead"
                v-model="info.personCardUpList"
                max-count="1"
                preview-size="100%"
                :upload-icon="require('../../assets/img/uploader.png')"
                :max-size="3686.4 * 1024"
                @oversize="onOversize"
              >
              </van-uploader>
              <p v-show="radio == 1">身份证正面</p>
            </div>
          </template>
        </van-field>
        <van-field
          name="cardDown"
          :rules="[{ validator: asyncValidator, message: '请上传身份证反面', trigger:onSubmit }]"
          style="padding: 0;flex: 0 0 3.73333rem"
          v-if="radio == 1"
        >
          <template #input>
            <div class="uploader-common">
              <van-uploader
                name="cardDown"
                :after-read="afterRead"
                v-model="info.personCardDownList"
                max-count="1"
                preview-size="100%"
                :upload-icon="require('../../assets/img/uploader.png')"
                :max-size="3686.4 * 1024"
                @oversize="onOversize"
              >
              </van-uploader>
              <p>身份证反面</p>
            </div>
          </template>
        </van-field>
      </div>
      <div class="line van-hairline--bottom"></div>
      <van-field
        v-model.trim="info.company"
        :label="`${isManager==0 ? '公司' : '店长'}名称`"
        maxlength="20"
        :placeholder="`请输入${isManager==0 ? '公司' : '店长'}名称`"
        label-width="3.06667rem"
        :rules="[{ validator: asyncValidator, message: `请输入${isManager==0 ? '公司' : '店长'}名称`, trigger:onSubmit }]"
      />
      <van-field
        v-model.trim="info.areaName"
        readonly
        label="选择地区"
        placeholder="请选择地区"
        label-width="3.06667rem"
        right-icon="arrow"
        @click="showArea = true"
        :rules="[{ validator: asyncValidator, message: '请选择地区', trigger:onSubmit }]"
      />
      <van-field
        v-model.trim="info.companyAdd"
        label="详细地址"
        placeholder="请输入详细地址"
        label-width="3.06667rem"
        maxlength="30"
        :rules="[{ validator: asyncValidator, message: '请输入详细地址', trigger:onSubmit }]"
      />
      <van-field
        v-model.trim="info.legalPerson"
        label="法人代表"
        placeholder="请输入法人代表"
        label-width="3.06667rem"
        maxlength="5"
        :rules="[{ validator: asyncValidator, message: '请输入法人代表', trigger:onSubmit }]"
        v-if="radio == 0"
      />
      <van-field
        v-model.trim="info.bussinessLicense"
        label="统一社会代用码"
        placeholder="请输入统一社会代用码"
        label-width="3.06667rem"
        maxlength="18"
        :rules="[{ validator: asyncValidator, message: '请输入统一社会代用码', trigger:onSubmit }, { pattern: pattern, message: '请输入正确的统一社会信用代码', trigger:onSubmit }]"
        v-if="radio == 0"
      />
      <van-field
        v-model.trim="info.telephone"
        readonly
        label="手机号码"
        placeholder="请输入手机号码"
        label-width="3.06667rem"
      />
      <van-field
        name="cardUp"
        :rules="[{ validator: asyncValidator, message: `请上传${isManager == 0 ? '公司' : '店长'}头像`, trigger:onSubmit }]"
      >
        <template #input>
          <div>
            <div class="uploader-title">{{isManager==0 ? '公司' : '店长'}}头像<span> （可上传{{isManager==0 ? '公司' : '店长'}}头像或代表性图片)</span></div>
            <div class="uploader-common">
              <van-uploader
                name="headpic"
                :after-read="afterRead"
                v-model="info.headpicList"
                max-count="1"
                preview-size="100%"
                :upload-icon="require('../../assets/img/uploader.png')"
                :max-size="3686.4 * 1024"
                @oversize="onOversize"
              >
              </van-uploader>
            </div>
          </div>
        </template>
      </van-field>
      <div class="btns">
        <van-button
          block
          text="提交审核"
          type="info"
          native-type="submit"
          color="#FFB14A"
        />
      </div>
    </van-form>
    <div class="fill"></div>
    <!-- 省市区弹窗 -->
    <van-popup
      v-model="showArea"
      :overlay="showArea"
      ref="popup"
      position="bottom"
      :lazy-render="false"
      :style="{ height: '68%' }"
    >
      <van-area
        ref="area"
        :area-list="areaList"
        :value="areaId"
        visible-item-count="9"
        @confirm="checkArea"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>

<script>
import areaLists from "@/utils/area.js";
import { uploadImageBase64, completeInformation } from "@/api/join";
export default {
  data() {
    return {
      radio: '0',
      info: {
        company: "",
        legalPerson: "",
        bussinessLicense: "",
        storePhone: "",
        personCardUpList: [],
        personCardUp: "",
        personCardDownList: [],
        personCardDown: "",
        headpicList: [],
        headpic: "",
        companyAdd: "",
        area: "",
        telephone: "",
        areaName: "",
      },
      showArea: false,
      areaList: areaLists, //省市区list
      areaId: "441302", // 区id
      isManager: 0, // 0、公司 1、店长
      pattern: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/, // 统一社会信用代码正则
      sellerApplyId: "",
      sellerId: ""
    };
  },
  methods: {
    // 验证错误提示
    onFailed(errorInfo) {
      this.$toast(errorInfo.errors[0].message);
    },
    // 提交审核
    onSubmit() {
      let fd = new FormData();
      fd.append("sellerId", this.info.sellerId);
      fd.append("sellerApplyId", this.info.sellerApplyId);
      fd.append("imageType", this.radio);
      fd.append("company", this.info.company);
      fd.append("province", this.info.province);
      fd.append("city", this.info.city);
      fd.append("area", this.info.area);
      fd.append("companyAdd", this.info.companyAdd);
      fd.append("legalPerson", this.info.legalPerson);
      fd.append("telephone", this.info.telephone);
      fd.append("headpic", this.info.headpic || this.info.sellerLogo);
      fd.append("bussinessLicense", this.info.bussinessLicense);
      fd.append("bussinessLicenseImage", this.radio == 0 ? this.info.bussinessLicenseImage : '');
      fd.append("personCardUp", this.radio == 1 ? this.info.personCardUp : '');
      fd.append("personCardDown", this.radio == 1 ? this.info.personCardDown : '');
      fd.append("sellerName", this.info.company);
      fd.append("storePhone", this.info.telephone);
      fd.append("provinceStore", this.info.province);
      fd.append("cityStore", this.info.city);
      fd.append("areaStore", this.info.area);
      fd.append("sellerAdd", this.info.companyAdd);
      completeInformation(fd).then(res => {
        if (res.appStatus.errorCode == 0) {
          this.$router.replace({ path: '/auditPublisher' })
        } else {
          this.$message.error(res.appStatus.message);
        }
      })
    },
    // 异步校验函数返回 Promise
    asyncValidator(val) {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$toast.clear();
          resolve(/\S/.test(val));
        }, 100);
      });
    },
    radioClick(e) {
      this.$dialog.alert({
        message: `<b>${e == 1 ? '是否更换为身份证证件上传，<br/>确认后将清空之前所填写的内容' : '是否更换为营业执照证件上传，<br/>确认后将清空之前所填写的内容'}</b>`,
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonColor: "#FFB14A",
        cancelButtonColor: "#606266",
      })
        .then(() => {
          this.radio = e;
          // 重置数据
          Object.assign(this.$data.info, this.$options.data().info);
          this.$set(this.info, "telephone", this.$route.params.perfectInfo.telephone);
        });
    },
    // 选择省市区
    checkArea(a) {
      this.showArea = false;
      this.info.areaName = `${a[0].name}/${a[1].name}/${a[2].name}`;
      this.info.province = a[0].code;
      this.info.city = a[1].code;
      this.info.area = a[2].code;
      this.areaId = a[2].code;
    },
    // 上传图片错误验证提示
    onOversize() {
      this.$toast("图片大小不能超过3.6M");
    },
    // 上传图片
    afterRead(file, detail) {
      file.status = "uploading";
      file.message = "上传中...";
      let self = this;
      let files = file.file;
      let reader = new FileReader();
      // 将图片2将转成 base64 格式
      reader.readAsDataURL(files);
      // 读取成功后的回调
      reader.onloadend = function () {
        let result = this.result;
        let img = new Image();
        img.src = result;
        self.postImg(file, detail, this.result);
      }
    },
    postImg(file, detail, image) {
      let base64 = image.slice(image.indexOf(",") + 1, image.length);
      let obj = {
        fileContent: base64,
      };
      uploadImageBase64(obj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          file.status = "done";
          file.message = "上传成功";
          if (detail.name == "cardUp") {
            this.info.personCardUp = res.content.path;
            this.info.bussinessLicenseImage = res.content.path;
          } else if (detail.name == "cardDown") {
            this.info.personCardDown = res.content.path;
          } else {
            this.info.headpic = res.content.path;
          }
        } else {
          file.status = "failed";
          file.message = "上传失败";
        }
      });
    },
  },
  mounted() {
    if (this.$route.params.perfectInfo) {
      // 选择省市区
      this.$refs.area.reset(this.$route.params.perfectInfo.area);
      //通过实例的getValues获取选中的列表
      let a = this.$refs.area.getValues();
      this.info.areaName = `${a[0].name}/${a[1].name}/${a[2].name}`;
      this.info.province = a[0].code;
      this.info.city = a[1].code;
      this.info.area = a[2].code;
    }
  },
  created() {
    this.isManager = this.$route.params.isManager;
    if (this.$route.params.perfectInfo) {
      this.radio = this.$route.params.perfectInfo.imageType || "0";
      for (let key in this.$route.params.perfectInfo) {
        this.$set(this.info, key, this.$route.params.perfectInfo[key]);
      }
      if (this.info.bussinessLicenseImage) {
        this.info.personCardUpList.push({ url: this.imgPrex + this.info.bussinessLicenseImage });
      }
      if (this.info.personCardUp) {
        this.info.personCardUpList.push({ url: this.imgPrex + this.info.personCardUp });
      }
      if (this.info.personCardDown) {
        this.info.personCardDownList.push({ url: this.imgPrex + this.info.personCardDown });
      }
      if (this.info.sellerLogo) {
        this.info.headpicList.push({ url: this.imgPrex + this.info.sellerLogo });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
  height: 30px;
  line-height: 30px;
  padding-left: 15px;
  font-size: 12px;
  color: #333333;
  background-color: #ffe9d5;
}
.radio-group {
  margin: 30px 0 30px 15px;
  .radio-text {
    font-size: 14px;
    color: #333333;
    &:first-of-type {
      margin-right: 40px;
    }
  }
}
.line {
  height: 1px;
  margin: 0 15px;
}
.uploader {
  width: 345px;
  min-height: 155px;
  margin: 0 15px;
  display: flex;
}
.uploader-title {
  margin-bottom: 15px;
  span {
    font-size: 12px;
    color: #999999;
  }
}
.uploader-common {
  width: 125px;
  font-size: 12px;
  color: #999999;
  &:first-of-type {
    margin-right: 15px;
  }
  p {
    margin-bottom: 20px;
    text-align: center;
  }
}
.mt15 {
  margin-top: 15px;
}
.btns {
  width: 345px;
  position: fixed;
  bottom: 28px;
  left: 15px;
  right: 0;
  border-radius: 5px;
  .van-button {
    height: 42px;
    line-height: 42px;
    .van-button__text {
      font-size: 16px;
    }
  }
}
.fill {
  height: 111px;
}
</style>
<style scoped>
.container >>> .van-field__label {
  margin-right: 0;
}
.uploader-common >>> .van-uploader__upload {
  margin: 0;
}
.uploader-common >>> .van-icon__image {
  width: 125px;
  height: 125px;
  display: block;
}
.uploader-common >>> .van-uploader__preview {
  width: 125px;
  height: 125px;
  margin: 0;
}
.radio-group >>> .van-radio__icon--disabled .van-icon {
  background-color: #fff;
}
.radio-group >>> .van-radio__icon--checked .van-icon {
  background-color: #FFB14A !important;
  border-color: #FFB14A !important;
}
.radio-group >>> .van-radio__label--disabled {
  color: #333333 !important;
}
</style>
